import UseCouponApi from '@/api/useCoupon'

const initialState = () => ({
  use_coupon: null
})

export const UseCoupon = {
  namespaced: true,
  state: initialState,
  getters: {
    use_coupon: state => state.use_coupon
  },
  mutations: {
    RESET_STATE (state) {
      const initial = initialState()
      Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    SET_USE_COUPON (state, item) {
      state.use_coupon = item
    }
  },
  actions: {
    getUseCoupon: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        UseCouponApi.getUseCoupon(payload)
          .then((response) => {
            if (response && response.title && response.message) {
              reject(response)
            } else {
              commit('SET_USE_COUPON', response.data && response.data.data)
              resolve()
            }
          })
      })
    }
  }
}
